import { Box, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Controller, useFormContext } from "react-hook-form";

import {
  AccountingActionCategory,
  AccountingActionLabel,
  ActionCategoryMapping,
  SUPPLIER_MULTI_SELECT_ACTIONS,
  SupplierAccountingActionAllowedTypes,
} from "@/features/chart-of-account-preferences";
import { ChartOfAccountSelect } from "@/features/chart-of-accounts";

const SUPPLIER_ACTIONS =
  ActionCategoryMapping[AccountingActionCategory.SUPPLIER];

export const AccountingSection = () => {
  const { control } = useFormContext();

  return (
    <Grid container spacing={3}>
        {SUPPLIER_ACTIONS.map((action) => {
          const isMultiple = SUPPLIER_MULTI_SELECT_ACTIONS.has(action);
          return (
            <Grid size={{ xs: 12, md: 6 }} key={action}>
              <Stack spacing={1}>
                <Box>
                  <Typography variant="subtitle1" gutterBottom>
                    {AccountingActionLabel[action]}
                  </Typography>
                  <Controller
                    control={control}
                    name={`accountingActionChartOfAccounts.${action}`}
                    render={({ field }) => (
                      <ChartOfAccountSelect
                        multiple={isMultiple}
                        types={SupplierAccountingActionAllowedTypes[action]}
                        value={
                          isMultiple ? field.value || [] : field.value || null
                        }
                        onChange={(value) =>
                          field.onChange(isMultiple ? value : value || null)
                        }
                        TextFieldProps={{
                          placeholder: "Cari dan pilih akun...",
                        }}
                      />
                    )}
                  />
                </Box>
              </Stack>
            </Grid>
          );
        })}
      </Grid>
  );
};
